var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209.182,
    height: 47.073,
    viewBox: "0 0 209.182 47.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.537,0H185.645a23.537,23.537,0,0,1,23.537,23.537v0a23.536,23.536,0,0,1-23.536,23.536H23.536A23.536,23.536,0,0,1,0,23.537v0A23.537,23.537,0,0,1,23.537,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.515 4.056)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.792 17.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.535,705.653h2.159v4.9a6.861,6.861,0,0,1-2.211,1.158,8.489,8.489,0,0,1-2.6.4,7,7,0,0,1-3.387-.816,6.06,6.06,0,0,1-2.369-2.255,6.56,6.56,0,0,1,0-6.494,6.048,6.048,0,0,1,2.378-2.255,7.093,7.093,0,0,1,3.414-.816,7.456,7.456,0,0,1,2.808.509,5.514,5.514,0,0,1,2.124,1.492l-1.439,1.4a4.617,4.617,0,0,0-3.387-1.4,4.789,4.789,0,0,0-2.308.544,3.968,3.968,0,0,0-1.579,1.527,4.393,4.393,0,0,0-.57,2.247,4.323,4.323,0,0,0,.57,2.211,4.085,4.085,0,0,0,1.579,1.544,4.629,4.629,0,0,0,2.291.562,4.942,4.942,0,0,0,2.527-.632Z",
    transform: "translate(-724.268 -699.475)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.444 3.545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.444,737.48a4.478,4.478,0,0,1-1.781-1.711,5.117,5.117,0,0,1,0-4.958,4.5,4.5,0,0,1,1.781-1.7,5.687,5.687,0,0,1,5.142,0,4.5,4.5,0,0,1,1.782,1.7,5.117,5.117,0,0,1,0,4.958,4.479,4.479,0,0,1-1.782,1.711,5.689,5.689,0,0,1-5.142,0Zm4.563-2.071a3.25,3.25,0,0,0,0-4.247,2.681,2.681,0,0,0-2-.807,2.651,2.651,0,0,0-1.992.807,3.277,3.277,0,0,0,0,4.247,2.651,2.651,0,0,0,1.992.807A2.68,2.68,0,0,0,862.007,735.409Z",
    transform: "translate(-855.022 -728.494)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.764 3.545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M967.544,737.48a4.478,4.478,0,0,1-1.782-1.711,5.118,5.118,0,0,1,0-4.958,4.5,4.5,0,0,1,1.782-1.7,5.687,5.687,0,0,1,5.142,0,4.5,4.5,0,0,1,1.781,1.7,5.117,5.117,0,0,1,0,4.958,4.481,4.481,0,0,1-1.781,1.711,5.689,5.689,0,0,1-5.142,0Zm4.563-2.071a3.251,3.251,0,0,0,0-4.247,2.682,2.682,0,0,0-2-.807,2.652,2.652,0,0,0-1.992.807,3.277,3.277,0,0,0,0,4.247,2.651,2.651,0,0,0,1.992.807A2.681,2.681,0,0,0,972.107,735.409Z",
    transform: "translate(-965.122 -728.494)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.084 3.545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.3,728.6v7.951q0,4.949-5.055,4.949a9.38,9.38,0,0,1-2.562-.342,5.44,5.44,0,0,1-2-.992l.983-1.65a4.7,4.7,0,0,0,1.553.816,6.1,6.1,0,0,0,1.9.307,3.144,3.144,0,0,0,2.264-.7,2.87,2.87,0,0,0,.72-2.141V736.3a3.6,3.6,0,0,1-1.369.93,4.827,4.827,0,0,1-1.773.316,5.084,5.084,0,0,1-2.413-.57,4.28,4.28,0,0,1-1.7-1.606,4.8,4.8,0,0,1,0-4.73,4.242,4.242,0,0,1,1.7-1.588,5.15,5.15,0,0,1,2.413-.562,4.947,4.947,0,0,1,1.851.333,3.417,3.417,0,0,1,1.4,1.018V728.6Zm-2.958,6.344a2.531,2.531,0,0,0,.8-1.939,2.483,2.483,0,0,0-.8-1.913,3.228,3.228,0,0,0-4.107,0,2.484,2.484,0,0,0-.8,1.913,2.531,2.531,0,0,0,.8,1.939,3.2,3.2,0,0,0,4.107,0Z",
    transform: "translate(-1075.222 -728.494)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1201.2,694.012h2.194v13.023H1201.2Z",
    transform: "translate(-1201.196 -694.012)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.336 3.545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1252.563,733.987h-7.354a2.548,2.548,0,0,0,1.009,1.641,3.308,3.308,0,0,0,2.027.605,3.416,3.416,0,0,0,2.545-1.018l1.176,1.351a3.961,3.961,0,0,1-1.6,1.141,6.33,6.33,0,0,1-4.9-.228,4.423,4.423,0,0,1-1.816-1.711,4.827,4.827,0,0,1-.641-2.483,4.9,4.9,0,0,1,.623-2.466,4.417,4.417,0,0,1,1.729-1.711,5.042,5.042,0,0,1,2.492-.614,4.918,4.918,0,0,1,2.448.606,4.294,4.294,0,0,1,1.685,1.7,5.169,5.169,0,0,1,.6,2.536Q1252.6,733.566,1252.563,733.987Zm-6.485-3.115a2.62,2.62,0,0,0-.886,1.659h5.318a2.589,2.589,0,0,0-.86-1.65,2.617,2.617,0,0,0-1.79-.632A2.647,2.647,0,0,0,1246.078,730.872Z",
    transform: "translate(-1243.015 -728.494)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.08 0.737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1413.7,701.709a4.044,4.044,0,0,1,1.817,1.509,4.611,4.611,0,0,1,0,4.66,4.024,4.024,0,0,1-1.817,1.518,6.8,6.8,0,0,1-2.782.527h-2.773v3.545h-2.282V701.182h5.055A6.8,6.8,0,0,1,1413.7,701.709Zm-.623,5.651a2.5,2.5,0,0,0,0-3.615,3.505,3.505,0,0,0-2.264-.632h-2.668v4.879h2.668A3.505,3.505,0,0,0,1413.074,707.36Z",
    transform: "translate(-1405.861 -701.182)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1527.74,694.012h2.194v13.023h-2.194Z",
    transform: "translate(-1527.74 -694.012)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.016 3.545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1578,729.486a3.833,3.833,0,0,1,1.1,2.992v5.493h-2.071v-1.141a2.552,2.552,0,0,1-1.15.939,4.5,4.5,0,0,1-1.8.325,4.408,4.408,0,0,1-1.843-.36,2.844,2.844,0,0,1-1.22-1,2.536,2.536,0,0,1-.43-1.448,2.482,2.482,0,0,1,.939-2.027,4.663,4.663,0,0,1,2.957-.763h2.422v-.14a1.92,1.92,0,0,0-.588-1.509,2.543,2.543,0,0,0-1.746-.527,5.043,5.043,0,0,0-1.553.246,3.829,3.829,0,0,0-1.29.684l-.86-1.6a5.328,5.328,0,0,1,1.773-.86,7.887,7.887,0,0,1,2.194-.3A4.571,4.571,0,0,1,1578,729.486Zm-2,6.634a2.053,2.053,0,0,0,.9-1.079v-1.088h-2.264q-1.9,0-1.9,1.246a1.118,1.118,0,0,0,.474.948,2.171,2.171,0,0,0,1.317.351A2.832,2.832,0,0,0,1576,736.12Z",
    transform: "translate(-1570.584 -728.494)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.424 3.651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1672.592,729.518l-4.388,10.127a4.717,4.717,0,0,1-1.492,2.15,3.575,3.575,0,0,1-2.124.623,4.359,4.359,0,0,1-1.386-.228,3.068,3.068,0,0,1-1.124-.632l.878-1.615a2.39,2.39,0,0,0,.746.474,2.285,2.285,0,0,0,.869.176,1.5,1.5,0,0,0,.957-.3,2.647,2.647,0,0,0,.693-1l.158-.369-4.09-9.407h2.282l2.949,6.933,2.966-6.933Z",
    transform: "translate(-1662.079 -729.518)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.864)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.828 11.613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.474,676.377l-5.9-3.4-4.85,4.689,4.433,4.285,6.315-3.645a1.112,1.112,0,0,0,0-1.926Z",
    transform: "translate(-578.726 -672.974)",
    fill: "#ffd109"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.423,571.06l-6.49-3.746-14.223-7.289,16.065,15.529Z",
    transform: "translate(-414.71 -560.025)",
    fill: "#06ef79"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.2 17.074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.006,741.4l14.011-7.718,6.048-3.491-4.231-4.09Z",
    transform: "translate(-417.006 -726.095)",
    fill: "#f93646"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.347,566.136l-.015,31.361,16.229-15.688Z",
    transform: "translate(-405.331 -566.136)",
    fill: "#05d5fb"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(33.622 9.504) rotate(0.134)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "SegoeUI-Semilight, Segoe UI",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Szerezd be itt"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.c56c7b4dad27aa75ef3feca32ef2871a.svg";
export { ForwardRef as ReactComponent };